import { useState, useEffect } from "react";

function GmmPage() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showInput, setShowInput] = useState(false);

  // ✅ MOBILE CHECK
  const isMobile =
    /Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );

  // ✅ FIXED OFFER CODE
  const offerCode = "9919910026";
  const heRedirectUrl = "https://ghanagameium.com/api/cgw/callback";
  const heMobileNumber = "99999999999";

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    const connectionType = connection?.type?.toLowerCase();
    const isMobileView = window.matchMedia("(max-width: 767px)").matches;
    const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const shouldUseNheOnMobile =
      isMobileDevice && isMobileView && connectionType === "wifi";

    setShowInput(params.get("fallback") === "true" || shouldUseNheOnMobile);
  }, []);

  useEffect(() => {
    const loggedIn =
      localStorage.getItem("isLoggedIn") === "true";

    if (loggedIn) {
      window.location.href = "/play";
    }
  }, []);

  // =====================================
  // SUBSCRIBE BUTTON
  // =====================================

  const handleSubscribe = () => {

    localStorage.setItem("offerCode", offerCode);

    // ✅ MOBILE DIRECT REDIRECT
    if (isMobile && !showInput) {

      const params = new URLSearchParams({
        offerCode,
        redirectUrl: heRedirectUrl,
        mobileNumber: heMobileNumber
      });

      const finalUrl = `/api/cgw/he-redirect?${params.toString()}`;

      console.log("🚀 FINAL URL:", finalUrl);

      // ✅ DIRECT REDIRECT
      window.location.href = finalUrl;

      return;
    }

    // ✅ DESKTOP → NHE FLOW
    fallbackNHE();
  };

  // =====================================
  // NHE FLOW
  // =====================================

  const fallbackNHE = () => {

    if (!phoneNumber) {
      alert("Enter phone number");
      return;
    }

    if (phoneNumber.length < 9) {
      alert("Enter valid number");
      return;
    }

    // ✅ GHANA FORMAT
    const msisdn = "233" + phoneNumber;

    // ✅ BACKEND URL
    const params = new URLSearchParams({
      offerCode,
      msisdn
    });

    window.location.href = `/api/cgw/generate-url?${params.toString()}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden px-3">

      {/* ===================================== */}
      {/* BACKGROUND */}
      {/* ===================================== */}

      <div className="absolute inset-0">

        <div className="absolute w-[400px] h-[400px] md:w-[600px] md:h-[600px] bg-red-600 blur-[200px] opacity-40 top-[-150px] left-[-150px]"></div>

        <div className="absolute w-[400px] h-[400px] md:w-[600px] md:h-[600px] bg-purple-600 blur-[200px] opacity-40 bottom-[-150px] right-[-150px]"></div>

      </div>

      {/* ===================================== */}
      {/* CARD */}
      {/* ===================================== */}

      <div className="relative z-10 w-full max-w-md p-[2px] rounded-3xl bg-gradient-to-r from-red-500 via-pink-500 to-purple-500 shadow-[0_0_40px_rgba(255,0,100,0.6)]">

        <div className="bg-[#0b0b15]/95 backdrop-blur-xl rounded-3xl p-6 md:p-8 text-center">

          <h3 className="text-xs md:text-sm tracking-widest text-gray-300 mb-2">
            WELCOME TO
          </h3>

          <h2 className="text-2xl md:text-3xl font-extrabold bg-gradient-to-r from-red-500 to-purple-500 bg-clip-text text-transparent mb-4">
            GHANA GAMEIUM
          </h2>

          <p className="text-gray-300 text-sm md:text-base mb-6 leading-relaxed">
            Level up your experience with non-stop games,
            epic challenges, and endless entertainment —
            all in one place!
          </p>

          {/* PRICE */}

          <div className="mb-6 p-[1px] rounded-xl bg-gradient-to-r from-red-500 to-purple-500">

            <div className="bg-black rounded-xl py-3 px-4 flex items-center justify-center gap-2">

              <span className="text-red-500 text-xl">
                ⚡
              </span>

              <span className="text-gray-300 text-xs md:text-sm">
                SUBSCRIBE FOR JUST
              </span>

              <span className="text-yellow-400 font-bold text-lg">
                GHS 1
              </span>

              <span className="text-gray-300 text-xs md:text-sm">
                DAILY
              </span>

            </div>

          </div>

          {/* ✅ DESKTOP INPUT */}

          {(!isMobile || showInput) && (
            <input
              type="tel"
              placeholder="Enter MTN number"
              value={phoneNumber}
              onChange={(e) =>
                setPhoneNumber(e.target.value)
              }
              className="w-full mb-4 px-4 py-3 rounded-xl bg-black/50 text-white border border-white/20 outline-none"
            />
          )}

          {/* BUTTON */}

          <button
            onClick={handleSubscribe}
            className="w-full py-3 md:py-4 rounded-xl bg-gradient-to-r from-red-500 to-purple-500 text-white font-bold text-lg shadow-lg hover:scale-105 transition"
          >
            LET’S PLAY →
          </button>

        </div>
      </div>
    </div>
  );
}

export default GmmPage;
